'use client';

import {
  isServer,
  QueryClient,
  QueryClientProvider
} from '@tanstack/react-query';

function makeQueryClient() {
  return new QueryClient( {
    defaultOptions: {
      queries: {
        staleTime: 30 * 1000, // data is considered fresh for 30 seconds
        gcTime: 5 * 60 * 1000, // unused data is garbage collected after 5 minutes
        retry: ( failureCount, error ) => {
          // don't retry auth errors
          const statusCode = ( error as any )?.statusCode;
          if ( statusCode === 401 || statusCode === 403 ) {
            return false;
          }

          // retry other errors up to 2 times
          return failureCount < 2;
        }
      }
    }
  } );
}

let browserQueryClient: QueryClient | undefined = undefined;

function getQueryClient() {
  // Until we migrate off next.js, client routes may still be rendered on the server
  if ( isServer ) {
    return makeQueryClient();
  } else {
    if ( !browserQueryClient ) browserQueryClient = makeQueryClient();
    return browserQueryClient;
  }
}

export default function Providers( { children }: { children: React.ReactNode } ) {
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={ queryClient }>{children}</QueryClientProvider>
  );
}